import { FormElementMeta } from '@people-science/forms-core';

// Web and native each register a plugin for this element. The persisted value
// shape and validate() live here so the two cannot disagree about whether a
// section is complete.

export interface FormVideoConfig {
  maxDurationSeconds?: number;
  minDurationSeconds?: number;
  videoBitrateMbps?: number;
  captureAffectTelemetry?: boolean;
}

/** What is persisted. */
export type StoredVideoValue = {
  videoKey: string;
  telemetryKey?: string;
  durationSeconds: number;
  capturedWidth: number;
  capturedHeight: number;
};

export const isStored = (value: any): value is StoredVideoValue =>
  Boolean(value && typeof value === 'object' && value.videoKey);

// a recorded-but-unuploaded value holds no videoKey, so the section stays
// incomplete and the transition blocked
export const validateVideoValue = (
  element: FormElementMeta<any, FormVideoConfig>,
  formValues: any
): boolean => {
  const value = formValues?.[element.dataSource || element.key];
  if (value === null || typeof value === 'undefined') return !element.required;
  return isStored(value);
};
